import React, { useState } from 'react';
import styled from 'styled-components';
import { Editor } from 'react-draft-wysiwyg';
import { EditorState, convertToRaw, ContentState } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

const Container = styled.div`
  .rdw-editor-main {
    border: 1px solid #f1f1f1;
    padding: 0 15px;
    min-height: 250px;
  }
`;

const WysiwygEditor = ({ onChange, value }) => {
  const [editor, setEditor] = useState();
  const contentBlock = htmlToDraft(value);

  // if (contentBlock) {
  //   const contentState = ContentState.createFromBlockArray(
  //     contentBlock.contentBlocks,
  //   );
  //   const editorState = EditorState.createWithContent(contentState);
  //   [editor, setEditor] = useState(editorState);
  // }

  return (
    <Container>
      <Editor
        editorState={editor}
        onEditorStateChange={editorState => {
          setEditor(editorState);
          const htmlContent = draftToHtml(
            convertToRaw(editorState.getCurrentContent()),
          );
          onChange(htmlContent);
        }}
      />
    </Container>
  );
};

export default WysiwygEditor;
